export default __webpack_public_path__ + "87d61cea6fe1d235d4a8a70304d05603.ttf";